import config from "@Config/index";

export const FLAG_BASE_URL = config.IS_CHINA_APP
  ? `${config.IMAGE_STATIC_URL}/images/`
  : `${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/`;
export const CITY_BASE_URL = `${config.IMAGE_ASSETS_URL}/regions/`;

export type PopularCountry = (typeof POPULAR_COUNTRIES)[number]["name"];

const POPULAR_COUNTRIES = [
  {
    id: 1,
    name: "United Kingdom",
    name_zh: "英国",
    shortName: "UK",
    icon: `${FLAG_BASE_URL}flag-uk.svg`,
    popular_cities: [
      {
        id: 14,
        name: "London",
        name_zh: "伦敦",
        canonical_name: "london-1811028205760",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_London_London Eye.webp?w=330&h=330`,
      },
      {
        id: 67,
        name: "Birmingham",
        name_zh: "伯明翰",
        canonical_name: "birmingham-1811028953945",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Birmingham_Birmingham Museum and Art Gallery.webp?w=330&h=330`,
      },
      {
        id: 75,
        name: "Leicester",
        name_zh: "莱斯特",
        canonical_name: "leicester-1811027154774",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Leicester_Leicester Cathedral.webp?w=330&h=330`,
      },
      {
        id: 34,
        name: "Nottingham",
        name_zh: "诺丁汉",
        canonical_name: "nottingham-1811025104223",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Nottingham_City Hall.webp?w=330&h=330`,
      },
      {
        id: 55,
        name: "Liverpool",
        name_zh: "利物浦",
        canonical_name: "liverpool-1811029039831",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Liverpool_Liverpool Cathedral.webp?w=330&h=330`,
      },
      {
        id: 70,
        name: "Coventry",
        name_zh: "考文垂",
        canonical_name: "coventry-1811022688464",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Coventry_Coventry Cathedral.webp?w=330&h=330`,
      },
      {
        id: 37,
        name: "Sheffield",
        name_zh: "谢菲尔德",
        canonical_name: "sheffield-1811027902898",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Sheffield_The+Crucible+Theatre.webp?w=330&h=330`,
      },
      {
        id: 43,
        name: "Leeds",
        name_zh: "利兹",
        canonical_name: "leeds-1811025399073",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Leeds_Royal Armouries Museum.webp?w=330&h=330`,
      },
      {
        id: 32,
        name: "Newcastle Upon Tyne",
        name_zh: "泰恩河畔纽卡斯尔",
        canonical_name: "newcastle-upon-tyne-1811022588361",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Newcastle Upon Tyne_The Tyne River and Bridge.webp?w=330&h=330`,
      },
      {
        id: 56,
        name: "Manchester",
        name_zh: "曼彻斯特",
        canonical_name: "manchester-1811021510595",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Manchester_The Lowry.webp?w=330&h=330`,
      },
      {
        id: 69,
        name: "Cardiff",
        name_zh: "卡迪夫",
        canonical_name: "cardiff-1811021315133",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Cardiff_Cardiff Castle.webp?w=330&h=330`,
      },
      {
        id: 64,
        name: "Swansea",
        name_zh: "斯旺西",
        canonical_name: "swansea-1811021718098",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Swansea_Swansea Marina.webp?w=330&h=330`,
      },
      {
        id: 71,
        name: "Edinburgh",
        name_zh: "爱丁堡",
        canonical_name: "edinburgh-1811029850773",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Edinburg_Edinburgh Castle.webp?w=330&h=330`,
      },
      {
        id: 76,
        name: "Salford",
        name_zh: "索尔福德",
        canonical_name: "salford-1811020307274",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Salford_University of Salford.webp?w=330&h=330`,
      },
      {
        id: 74,
        name: "Plymouth",
        name_zh: "普利茅斯",
        canonical_name: "plymouth-1811024617468",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Plymouth_National Marine Aquarium.webp?w=330&h=330`,
      },
      {
        id: 19,
        name: "Aberdeen",
        name_zh: "阿伯丁",
        canonical_name: "aberdeen-1811021824528",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Aberdeen_St. Machar_s Cathedral.webp?w=330&h=330`,
      },
      {
        id: 46,
        name: "Chester",
        name_zh: "切斯特",
        canonical_name: "chester-1811022260382",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Chester_Chester Cathedral.webp?w=330&h=330`,
      },
      {
        id: 29,
        name: "Lincoln",
        name_zh: "林肯",
        canonical_name: "lincoln-1811026319691",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Lincoln_Lincoln Cathedral.webp?w=330&h=330`,
      },
      {
        id: 50,
        name: "Exeter",
        name_zh: "埃克塞特",
        canonical_name: "exeter-1811027484452",
        image: `${CITY_BASE_URL}Popular-Cities/UK/UK_Exeter_Exeter Cathedral.webp?w=330&h=330`,
      },
    ],
  },
  {
    id: 2,
    name: "Australia",
    name_zh: "澳大利亚",
    shortName: "AUS",
    icon: `${FLAG_BASE_URL}flag-aus.svg`,
    popular_cities: [
      {
        id: 10,
        name: "Melbourne",
        name_zh: "墨尔本",
        canonical_name: "melbourne-1811011846366",
        image: `${CITY_BASE_URL}Popular-Cities/Australia/Australia_1_Melbourne_Federation Square.png?w=330&h=330`,
      },
      {
        id: 178,
        name: "Brisbane",
        name_zh: "布里斯班",
        canonical_name: "brisbane-1811022382320",
        image: `${CITY_BASE_URL}Popular-Cities/Australia/Australia_2_Brisbane_South Bank Parklands.png?w=330&h=330`,
      },
      {
        id: 9,
        name: "Sydney",
        name_zh: "悉尼",
        canonical_name: "sydney-1811019193619",
        image: `${CITY_BASE_URL}Popular-Cities/Australia/Australia_3_Sydney_Sydney Opera House.png?w=330&h=330`,
      },
      {
        id: 175,
        name: "Adelaide",
        name_zh: "阿德莱德",
        canonical_name: "adelaide-1811022271790",
        image: `${CITY_BASE_URL}Popular-Cities/Australia/Australia_4_Adelaide_Adelaide Central Market.png?w=330&h=330`,
      },
      {
        id: 180,
        name: "Perth",
        name_zh: "珀斯",
        canonical_name: "perth-1811021246766",
        image: `${CITY_BASE_URL}Popular-Cities/Australia/Australia_5_Perth_Hillarys Boat Harbour.png?w=330&h=330`,
      },
      {
        id: 177,
        name: "Canberra",
        name_zh: "堪培拉",
        canonical_name: "canberra-1811028680774",
        image: `${CITY_BASE_URL}Popular-Cities/Australia/Australia_6_Canberra_National Gallery of Australia.png?w=330&h=330`,
      },
      {
        id: 518,
        name: "Gold Coast",
        name_zh: "黄金海岸",
        canonical_name: "gold-coast-1811055204067",
        image: `${CITY_BASE_URL}Popular-Cities/Australia/Australia_7_Gold Coast_HOTA Gallery.png?w=330&h=330`,
      },
      {
        id: 182,
        name: "Coffs Harbour",
        name_zh: "科夫斯港",
        canonical_name: "coffs-harbour-1811023024156",
        image: `${CITY_BASE_URL}Popular-Cities/Australia/Australia_8_Coffs Harbour_Coffs Harbour Jetty.png?w=330&h=330`,
      },
    ],
  },
  {
    id: 3,
    name: "Ireland",
    name_zh: "爱尔兰",
    shortName: "IRE",
    icon: `${FLAG_BASE_URL}flag-ire.svg`,
    popular_cities: [
      {
        id: 994,
        name: "Dublin",
        name_zh: "都柏林",
        canonical_name: "dublin-1811234255126",
        image: `${CITY_BASE_URL}Popular-Cities/Ireland/Ireland_Dublin_Trinity College.webp?w=330&h=330`,
      },
      {
        id: 1572,
        name: "Cork",
        name_zh: "科克",
        canonical_name: "cork-1905110396319",
        image: `${CITY_BASE_URL}Popular-Cities/Ireland/Ireland_Cork_Blarney Castle.webp?w=330&h=330`,
      },
    ],
  },
  {
    id: 4,
    name: "United States",
    name_zh: "美国",
    shortName: "USA",
    icon: `${FLAG_BASE_URL}flag-us.svg`,
    popular_cities: [
      {
        id: 734,
        name: "New York City",
        name_zh: "纽约市",
        canonical_name: "new-york-city-1811153579499",
        image: `${CITY_BASE_URL}Popular-Cities/USA/USA_1_New York City_Statue of Liberty.png?w=330&h=330`,
      },
      {
        id: 490,
        name: "Chicago",
        name_zh: "芝加哥",
        canonical_name: "chicago-1811055213730",
        image: `${CITY_BASE_URL}Popular-Cities/USA/USA_7_Chicago_Millennium Park.png?w=330&h=330`,
      },
      {
        id: 426,
        name: "Austin",
        name_zh: "奥斯汀",
        canonical_name: "austin-1811059470166",
        image: `${CITY_BASE_URL}Popular-Cities/USA/USA_2_Austin_Texas State Capitol.png?w=330&h=330`,
      },
      {
        id: 422,
        name: "Houston",
        name_zh: "休斯敦",
        canonical_name: "houston-1811053554207",
        image: `${CITY_BASE_URL}Popular-Cities/USA/USA_8_Houston_Hermann Park.png?w=330&h=330`,
      },
      {
        id: 1076,
        name: "San Francisco",
        name_zh: "旧金山",
        canonical_name: "san-francisco-1811261246298",
        image: `${CITY_BASE_URL}Popular-Cities/USA/USA_3_San Fransico_Alcatraz Island.png?w=330&h=330`,
      },
      {
        id: 492,
        name: "Boston",
        name_zh: "波士顿",
        canonical_name: "boston-1811058601037",
        image: `${CITY_BASE_URL}Popular-Cities/USA/USA_9_Boston_Boston Common.png?w=330&h=330`,
      },
      {
        id: 424,
        name: "Dallas",
        name_zh: "达拉斯",
        canonical_name: "dallas-1811050789451",
        image: `${CITY_BASE_URL}Popular-Cities/USA/USA_4_Dallas_Sixth Floor Museum at Dealey Plaza.png?w=330&h=330`,
      },
      {
        id: 778,
        name: "Washington DC",
        name_zh: "华盛顿特区",
        canonical_name: "washington-dc-1811157116879",
        image: `${CITY_BASE_URL}Popular-Cities/USA/USA_10_Washington DC_Smithsonian Institution.png?w=330&h=330`,
      },
      {
        id: 500,
        name: "Philadelphia",
        name_zh: "费城",
        canonical_name: "philadelphia-1811050668830",
        image: `${CITY_BASE_URL}Popular-Cities/USA/USA_5_Philadelphia_Independence Hall.png?w=330&h=330`,
      },
      {
        id: 488,
        name: "College Station",
        name_zh: "学院站",
        canonical_name: "college-station-1811055669049",
        image: `${CITY_BASE_URL}Popular-Cities/USA/USA_11_College Station_Texas A&M University.png?w=330&h=330`,
      },
      {
        id: 498,
        name: "Los Angeles",
        name_zh: "洛杉矶",
        canonical_name: "los-angeles-1811059549842",
        image: `${CITY_BASE_URL}Popular-Cities/USA/USA_6_Los Angeles_Griffith Observatory.png?w=330&h=330`,
      },
      {
        id: 1944,
        name: "Lubbock",
        name_zh: "拉伯克",
        canonical_name: "lubbock-2208021988942",
        image: `${CITY_BASE_URL}Popular-Cities/USA/USA_12_Lubbock_Texas Tech University.png?w=330&h=330`,
      },
      {
        id: 720,
        name: "Miami",
        name_zh: "迈阿密",
        canonical_name: "miami-1811158634551",
        image: `${CITY_BASE_URL}Popular-Cities/USA/USA_13_Miami_Vizcaya Museum and Gardens.png?w=330&h=330`,
      },
      {
        id: 1900,
        name: "Minneapolis",
        name_zh: "明尼阿波利斯",
        canonical_name: "minneapolis-2111049904626",
        image: `${CITY_BASE_URL}Popular-Cities/USA/USA_14_Minneapolis_Minneapolis Institute of Art.png?w=330&h=330`,
      },
      // {
      //   id: 1838,
      //   name: 'Atlanta',
      //   canonical_name: 'atlanta-2103038343998',
      //   image: `${CITY_BASE_URL}/ATLANTA/ATLANTA_2.png?w=330&h=330`,
      // },
      // {
      //   id: 1907,
      //   name: 'Buffalo',
      //   canonical_name: 'buffalo-2111046904535',
      //   image: `${CITY_BASE_URL}/BUFFALO/BUFFALO_2.png?w=330&h=330`,
      // },
    ],
  },
  {
    id: 5,
    name: "Canada",
    name_zh: "加拿大",
    shortName: "CAN",
    icon: `${FLAG_BASE_URL}flag-can.svg`,
    popular_cities: [
      {
        id: 1744,
        name: "Toronto",
        name_zh: "多伦多",
        canonical_name: "toronto-1912205118632",
        image: `${CITY_BASE_URL}Popular-Cities/Canada/Canada_Toronto_Royal Ontario Museum.webp?w=330&h=330`,
      },
      {
        id: 1728,
        name: "Montreal",
        name_zh: "蒙特利尔",
        canonical_name: "montreal-1911254462968",
        image: `${CITY_BASE_URL}Popular-Cities/Canada/Canada_Montreal_Old Montreal.webp?w=330&h=330`,
      },
      {
        id: 1710,
        name: "Vancouver",
        name_zh: "温哥华",
        canonical_name: "vancouver-1911021542675",
        image: `${CITY_BASE_URL}Popular-Cities/Canada/Canada_Vancouver_Granville Island.webp?w=330&h=330`,
      },
      {
        id: 2121,
        name: "Ottawa",
        name_zh: "渥太华",
        canonical_name: "ottawa-2304201785556",
        image: `${CITY_BASE_URL}Popular-Cities/Canada/Canada_Ottawa.jpg?w=330&h=330`,
      },
      {
        id: 2447,
        name: "Waterloo",
        name_zh: "滑铁卢",
        canonical_name: "waterloo-2402226880061",
        image: `${CITY_BASE_URL}Popular-Cities/Canada/Canada_Waterloo.jpg?w=330&h=330`,
      },
    ],
  },
  {
    id: 6,
    name: "Germany",
    name_zh: "德国",
    shortName: "GER",
    icon: `${FLAG_BASE_URL}flag-ger.svg`,
    popular_cities: [
      {
        id: 1734,
        name: "Frankfurt",
        name_zh: "法兰克福",
        canonical_name: "frankfurt-1911264093661",
        image: `${CITY_BASE_URL}Popular-Cities/Germany/Germany_Frankfurter_Römer.webp?w=330&h=330`,
      },
      {
        id: 1826,
        name: "Hamburg",
        name_zh: "汉堡",
        canonical_name: "hamburg-2010057120842",
        image: `${CITY_BASE_URL}Popular-Cities/Germany/Germany_Hamburg_Speicherstadt.webp?w=330&h=330`,
      },
      {
        id: 1735,
        name: "Berlin",
        name_zh: "柏林",
        canonical_name: "berlin-1911262002763",
        image: `${CITY_BASE_URL}Popular-Cities/Germany/Germany_Berlin_Brandenburg Gate.webp?w=330&h=330`,
      },
      {
        id: 1736,
        name: "Munich",
        name_zh: "慕尼黑",
        canonical_name: "munich-1911268823914",
        image: `${CITY_BASE_URL}Popular-Cities/Germany/Germany_Munich.jpg?w=330&h=330`,
      },
    ],
  },
  // // Commenting since properties in Lisbon are sold out
  // {
  //   id: 7,
  //   name: 'Portugal',
  //   shortName: 'POR',
  //   icon: FLAG_BASE_URL + 'flag-por.svg',
  //   popular_cities: [
  //     { id: 1834, name: 'Lisbon', canonical_name: 'lisbon-2010153876668', image: `${CITY_BASE_URL}/Lisbon/Lisbon_4.jpg?w=330&h=330` },
  //   ],
  // },
  {
    id: 7,
    name: "Spain",
    name_zh: "西班牙",
    shortName: "ESP",
    icon: `${FLAG_BASE_URL}flag-esp.svg`,
    popular_cities: [
      {
        id: 1836,
        name: "Barcelona",
        name_zh: "巴塞罗那",
        canonical_name: "barcelona-2011053744668",
        image: `${CITY_BASE_URL}Popular-Cities/Spain/Spain_Barcelona_Sagrada Família.webp?w=330&h=330`,
      },
      {
        id: 1831,
        name: "Madrid",
        name_zh: "马德里",
        canonical_name: "madrid-2010152201808",
        image: `${CITY_BASE_URL}Popular-Cities/Spain/Spain_Madrid.jpg?w=330&h=330`,
      },
      {
        id: 1832,
        name: "Valencia",
        name_zh: "瓦伦西亚",
        canonical_name: "valencia-2010151704940",
        image: `${CITY_BASE_URL}Popular-Cities/Spain/Spain_Valencia.jpg?w=330&h=330`,
      },
      {
        id: 1946,
        name: "Seville",
        name_zh: "塞维利亚",
        canonical_name: "seville-2208080831405",
        image: `${CITY_BASE_URL}Popular-Cities/Spain/Spain_Seville.jpg?w=330&h=330`,
      },
    ],
  },
  {
    id: 8,
    name: "New Zealand",
    name_zh: "新西兰",
    shortName: "NZ",
    // icon: `${FLAG_BASE_URL}flag-nz.svg`,
    icon: "https://s3.ap-southeast-1.amazonaws.com/static-assets.amberstudent.com/images/flag-nz.svg",
    popular_cities: [
      {
        id: 1712,
        name: "Auckland",
        name_zh: "奥克兰",
        canonical_name: "auckland-1911021078582",
        image: `${CITY_BASE_URL}Popular-Cities/New_Zealand/Auckland.jpg?w=330&h=330`,
      },
      {
        id: 1714,
        name: "Wellington",
        name_zh: "惠灵顿",
        canonical_name: "wellington-1911020902254",
        image: `${CITY_BASE_URL}Popular-Cities/New_Zealand/Wellington.jpg?w=330&h=330`,
      },
    ],
  },
  {
    id: 9,
    name: "France",
    name_zh: "法国",
    shortName: "FR",
    // icon: `${FLAG_BASE_URL}flag-france.svg`,
    icon: "https://s3.ap-southeast-1.amazonaws.com/static-assets.amberstudent.com/images/flag-france.svg",
    popular_cities: [
      {
        id: 1730,
        name: "Paris",
        name_zh: "巴黎",
        canonical_name: "paris-1911265935013",
        image: `${CITY_BASE_URL}Popular-Cities/France/Paris.jpg?w=330&h=330`,
      },
    ],
  },
  {
    id: 10,
    name: "Singapore",
    name_zh: "新加坡",
    shortName: "SG",
    // icon: `${FLAG_BASE_URL}flag-singapore.svg`,
    icon: "https://s3.ap-southeast-1.amazonaws.com/static-assets.amberstudent.com/images/flag-singapore.svg",
    popular_cities: [
      {
        id: 1836,
        name: "Singapore",
        name_zh: "新加坡",
        canonical_name: "singapore-2506022501650",
        image: `${CITY_BASE_URL}Popular-Cities/Singapore/Singapore.jpg?w=330&h=330`,
      },
    ],
  },
  // {
  //   id: 11,
  //   name: "UAE",
  //   name_zh: "阿联酋",
  //   shortName: "AE",
  //   // icon: `${FLAG_BASE_URL}flag-uae.svg`,
  //   icon: "https://s3.ap-southeast-1.amazonaws.com/static-assets.amberstudent.com/images/flag-uae.svg",
  //   popular_cities: [
  //     {
  //       id: 1719,
  //       name: "Dubai",
  //       name_zh: "迪拜",
  //       canonical_name: "dubai-1911024693626",
  //       image: `${CITY_BASE_URL}Popular-Cities/UAE/Dubai.jpg?w=330&h=330`,
  //     },
  //   ],
  // },
] as const;

export default POPULAR_COUNTRIES;
